import { c as _c } from "react/compiler-runtime";
// @ts-nocheck
import { Percent, CurrencyUSD, Time, GraphQLDecimal } from '@/graphql/scalars';
import * as Types from '../../../types/schema';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminFormsPage_FormFragment = {
  __typename?: 'Form';
  id: string;
  name: string;
  description: string;
  draftSchemaVersion: number;
  draftConfig: any;
  updatedAt: Time;
  currentPublishedVersion?: {
    __typename?: 'FormVersion';
    id: string;
    version: number;
  } | null;
};
export type FormDraftImportContractQueryVariables = Types.Exact<{
  [key: string]: never;
}>;
export type FormDraftImportContractQuery = {
  __typename?: 'Query';
  formDraftImportContract: {
    __typename?: 'FormDraftImportContract';
    schemaVersion: number;
    jsonSchema: string;
    sampleJson: string;
  };
};
export type NormalizeFormDraftConfigMutationVariables = Types.Exact<{
  json: Types.Scalars['String']['input'];
}>;
export type NormalizeFormDraftConfigMutation = {
  __typename?: 'Mutation';
  normalizeFormDraftConfig: any;
};
export type AdminFormsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;
export type AdminFormsQuery = {
  __typename?: 'Query';
  forms: {
    __typename?: 'FormConnection';
    edges?: Array<{
      __typename?: 'FormEdge';
      node?: ({
        __typename?: 'Form';
        versions: {
          __typename?: 'FormVersionConnection';
          edges?: Array<{
            __typename?: 'FormVersionEdge';
            node?: {
              __typename?: 'FormVersion';
              id: string;
              version: number;
            } | null;
          } | null> | null;
        };
      } & AdminFormsPage_FormFragment) | null;
    } | null> | null;
  };
};
export type FormVersionConfigQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;
export type FormVersionConfigQuery = {
  __typename?: 'Query';
  node?: {
    __typename: 'AISuggestion';
  } | {
    __typename: 'AISuggestionEvidence';
  } | {
    __typename: 'AccessAgeParameter';
  } | {
    __typename: 'AccessParameter';
  } | {
    __typename: 'Account';
  } | {
    __typename: 'ActiveEstateInsightsPage';
  } | {
    __typename: 'Activity';
  } | {
    __typename: 'Address';
  } | {
    __typename: 'Answer';
  } | {
    __typename: 'AnswerEvidence';
  } | {
    __typename: 'AnswerRevision';
  } | {
    __typename: 'Approval';
  } | {
    __typename: 'AssetClass';
  } | {
    __typename: 'AssetGroup';
  } | {
    __typename: 'AssetStatic';
  } | {
    __typename: 'AssetV2';
  } | {
    __typename: 'AssetValuationV2';
  } | {
    __typename: 'AssetValueV2';
  } | {
    __typename: 'AsyncJob';
  } | {
    __typename: 'BalanceSheetBundleConfiguration';
  } | {
    __typename: 'BalanceSheetCategory';
  } | {
    __typename: 'BalanceSheetViewConfiguration';
  } | {
    __typename: 'BeneficiariesBundleConfiguration';
  } | {
    __typename: 'BeneficiariesTemplateBundleConfiguration';
  } | {
    __typename: 'Beneficiary';
  } | {
    __typename: 'BeneficiaryAccessParameter';
  } | {
    __typename: 'BeneficiaryDesignationGroup';
  } | {
    __typename: 'BeneficiaryDistribution';
  } | {
    __typename: 'BeneficiaryDistributionParameter';
  } | {
    __typename: 'BeneficiaryPage';
  } | {
    __typename: 'BeneficiaryPowerOfAppointment';
  } | {
    __typename: 'CCorpBusinessEntity';
  } | {
    __typename: 'CLTProposal';
  } | {
    __typename: 'CLTTrust';
  } | {
    __typename: 'CRTProposal';
  } | {
    __typename: 'CRTTrust';
  } | {
    __typename: 'Capability';
  } | {
    __typename: 'Cashflow';
  } | {
    __typename: 'ClientOrganization';
  } | {
    __typename: 'ClientPresentationV2';
  } | {
    __typename: 'ClientProfile';
  } | {
    __typename: 'ClientProfileRelationship';
  } | {
    __typename: 'Collaborator';
  } | {
    __typename: 'ComparedWaterfall';
  } | {
    __typename: 'CompletedEstateInsightsPage';
  } | {
    __typename: 'ControllingParty';
  } | {
    __typename: 'Conversation';
  } | {
    __typename: 'CoverPageConfiguration';
  } | {
    __typename: 'CustodialPersonalAccount';
  } | {
    __typename: 'DSUEPortability';
  } | {
    __typename: 'DiagramArtifact';
  } | {
    __typename: 'DiagramArtifactPrompt';
  } | {
    __typename: 'DispositionScenario';
  } | {
    __typename: 'DispositiveProvision';
  } | {
    __typename: 'DispositiveProvisionTemplate';
  } | {
    __typename: 'DividerBundleConfiguration';
  } | {
    __typename: 'DividerTemplateBundleConfiguration';
  } | {
    __typename: 'Document';
  } | {
    __typename: 'DocumentQuestion';
  } | {
    __typename: 'DocumentQuestionAnswers';
  } | {
    __typename: 'DocumentSummary';
  } | {
    __typename: 'DocumentSummaryPage';
  } | {
    __typename: 'DocumentSummaryPrompt';
  } | {
    __typename: 'DocumentSummaryPromptTestRun';
  } | {
    __typename: 'DocumentSummaryTemplateBundleConfiguration';
  } | {
    __typename: 'DonorAdvisedFund';
  } | {
    __typename: 'Employee';
  } | {
    __typename: 'EntitiesOverviewBundleConfiguration';
  } | {
    __typename: 'EntitiesOverviewBundleConfigurationEntity';
  } | {
    __typename: 'Entity';
  } | {
    __typename: 'EntityDiagram';
  } | {
    __typename: 'EntityDocumentRelationship';
  } | {
    __typename: 'EntityGraphView';
  } | {
    __typename: 'EntityGraphViewBundleConfiguration';
  } | {
    __typename: 'EntityNotes';
  } | {
    __typename: 'EntityProposal';
  } | {
    __typename: 'EntitySummaryBundleConfiguration';
  } | {
    __typename: 'EntitySummaryTemplateBundleConfiguration';
  } | {
    __typename: 'EntityTask';
  } | {
    __typename: 'EntityTaxInfo';
  } | {
    __typename: 'EstateInsight';
  } | {
    __typename: 'EstateInsightReference';
  } | {
    __typename: 'EstateInsightsBundleConfiguration';
  } | {
    __typename: 'EstateTaxScenario';
  } | {
    __typename: 'EstateWaterfall';
  } | {
    __typename: 'EstateWaterfallHypotheticalStateChange';
  } | {
    __typename: 'EstateWaterfallHypotheticalTransfer';
  } | {
    __typename: 'EstateWaterfallMessageContext';
  } | {
    __typename: 'EstateWaterfallVisualizationConfig';
  } | {
    __typename: 'EstateWaterfallVisualizationFilter';
  } | {
    __typename: 'FamilyTreeBundleConfiguration';
  } | {
    __typename: 'FamilyTreeConfiguration';
  } | {
    __typename: 'FeatureFlag';
  } | {
    __typename: 'FeatureFlagQueryRule';
  } | {
    __typename: 'File';
  } | {
    __typename: 'FilePage';
  } | {
    __typename: 'FileParagraph';
  } | {
    __typename: 'Form';
  } | {
    __typename: 'FormVersion';
    id: string;
    config: any;
  } | {
    __typename: 'GPBusinessEntity';
  } | {
    __typename: 'GRATAnnuityV2';
  } | {
    __typename: 'GRATProposalScenario';
  } | {
    __typename: 'GRATTrust';
  } | {
    __typename: 'GiftingProposal';
  } | {
    __typename: 'GiftingProposalCashFlow';
  } | {
    __typename: 'GiftingProposalGift';
  } | {
    __typename: 'GiftingProposalGiftSender';
  } | {
    __typename: 'GiftingProposalPortfolio';
  } | {
    __typename: 'GiftingProposalScenario';
  } | {
    __typename: 'GraphVisualizationGroup';
  } | {
    __typename: 'GrowthProfile';
  } | {
    __typename: 'GrowthProfileOverride';
  } | {
    __typename: 'Household';
  } | {
    __typename: 'HypotheticalCLT';
  } | {
    __typename: 'HypotheticalCRT';
  } | {
    __typename: 'HypotheticalGRAT';
  } | {
    __typename: 'HypotheticalInsurance';
  } | {
    __typename: 'HypotheticalSaleLoan';
  } | {
    __typename: 'HypotheticalTransferAsset';
  } | {
    __typename: 'HypotheticalTransferFundingSource';
  } | {
    __typename: 'HypotheticalWaterfallDispositiveProvisionTemplate';
  } | {
    __typename: 'ILITCrummeyLetter';
  } | {
    __typename: 'ILITTrust';
  } | {
    __typename: 'Image';
  } | {
    __typename: 'IncomeTaxPaymentConfig';
  } | {
    __typename: 'IndividualPersonalAccount';
  } | {
    __typename: 'InferredField';
  } | {
    __typename: 'InferredFieldEvidence';
  } | {
    __typename: 'InsightsTemplateBundleConfiguration';
  } | {
    __typename: 'InsurancePersonalAccount';
  } | {
    __typename: 'InsurancePolicy';
  } | {
    __typename: 'InsurancePremiumPayment';
  } | {
    __typename: 'IntegrationAssetClass';
  } | {
    __typename: 'IntegrationCashflow';
  } | {
    __typename: 'IntegrationClient';
  } | {
    __typename: 'IntegrationConfiguration';
  } | {
    __typename: 'IntegrationEntity';
  } | {
    __typename: 'IntegrationInsurance';
  } | {
    __typename: 'IntegrationLiability';
  } | {
    __typename: 'IntegrationPerson';
  } | {
    __typename: 'IrrevocableTrust';
  } | {
    __typename: 'JointPersonalAccount';
  } | {
    __typename: 'KGNode';
  } | {
    __typename: 'KGRelationship';
  } | {
    __typename: 'KGRoot';
  } | {
    __typename: 'KGV2Document';
  } | {
    __typename: 'KGV2DocumentChange';
  } | {
    __typename: 'KGV2DocumentModification';
  } | {
    __typename: 'KGV2Graph';
  } | {
    __typename: 'KGV2Node';
  } | {
    __typename: 'KGV2NodeAlias';
  } | {
    __typename: 'KGV2NodeEvidence';
  } | {
    __typename: 'KGV2Statement';
  } | {
    __typename: 'KGV2StatementEvidence';
  } | {
    __typename: 'KGV2StatementSupersession';
  } | {
    __typename: 'KeyPerson';
  } | {
    __typename: 'KeyPersonRole';
  } | {
    __typename: 'LLCBusinessEntity';
  } | {
    __typename: 'LPBusinessEntity';
  } | {
    __typename: 'LiabilitiesBundleConfiguration';
  } | {
    __typename: 'Liability';
  } | {
    __typename: 'LiabilityPayment';
  } | {
    __typename: 'LifeInsuranceBundleConfiguration';
  } | {
    __typename: 'LifetimeExclusionEvent';
  } | {
    __typename: 'LoggedTransfer';
  } | {
    __typename: 'LuminaryOrganization';
  } | {
    __typename: 'LuminaryTenantJIT';
  } | {
    __typename: 'ManagedSFTPConnection';
  } | {
    __typename: 'Memo';
  } | {
    __typename: 'MemoPrompt';
  } | {
    __typename: 'Message';
  } | {
    __typename: 'MissingDocumentOverride';
  } | {
    __typename: 'MissingDocumentsPage';
  } | {
    __typename: 'ModelMapping';
  } | {
    __typename: 'NotificationApp';
  } | {
    __typename: 'NotificationPreference';
  } | {
    __typename: 'OpenaiSdkConfig';
  } | {
    __typename: 'OrganizationApplicationConfiguration';
  } | {
    __typename: 'OrganizationDisclaimerConfiguration';
  } | {
    __typename: 'OwnershipStake';
  } | {
    __typename: 'PlatformDocument';
  } | {
    __typename: 'PlatformFile';
  } | {
    __typename: 'PlatformFilePage';
  } | {
    __typename: 'PlatformFileParagraph';
  } | {
    __typename: 'PresentationApprovalRequest';
  } | {
    __typename: 'PresentationAssetDistributionBundleConfiguration';
  } | {
    __typename: 'PresentationAssetDistributionItemConfiguration';
  } | {
    __typename: 'PresentationAssetDistributionItemDetail';
  } | {
    __typename: 'PresentationBundle';
  } | {
    __typename: 'PresentationBundleCoverPage';
  } | {
    __typename: 'PresentationBusinessOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationBusinessOverviewBusinessConfiguration';
  } | {
    __typename: 'PresentationBusinessOverviewItem';
  } | {
    __typename: 'PresentationCoverPage';
  } | {
    __typename: 'PresentationCoverSlideConfig';
  } | {
    __typename: 'PresentationCustomPage';
  } | {
    __typename: 'PresentationCustomPageBundleConfiguration';
  } | {
    __typename: 'PresentationDiagramPage';
  } | {
    __typename: 'PresentationDocumentsReviewedBundleConfiguration';
  } | {
    __typename: 'PresentationDocumentsReviewedDocument';
  } | {
    __typename: 'PresentationFamilyOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationFamilyOverviewMemberConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveBundleConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveClientConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveItem';
  } | {
    __typename: 'PresentationItemCitation';
  } | {
    __typename: 'PresentationPage';
  } | {
    __typename: 'PresentationPlanningOpportunitiesBundleConfiguration';
  } | {
    __typename: 'PresentationPlanningOpportunitiesItem';
  } | {
    __typename: 'PresentationPowerOfAttorneyBundleConfiguration';
  } | {
    __typename: 'PresentationPowerOfAttorneyClientConfiguration';
  } | {
    __typename: 'PresentationPowerOfAttorneyItem';
  } | {
    __typename: 'PresentationTemplate';
  } | {
    __typename: 'PresentationTemplateBundle';
  } | {
    __typename: 'PresentationTemplateCoverPage';
  } | {
    __typename: 'PresentationTemplateCustomPage';
  } | {
    __typename: 'PresentationTemplateDiagramPage';
  } | {
    __typename: 'PresentationTemplatePage';
  } | {
    __typename: 'PresentationTrustOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationTrustOverviewItem';
  } | {
    __typename: 'PresentationTrustOverviewTrustConfiguration';
  } | {
    __typename: 'PresentationWillBundleConfiguration';
  } | {
    __typename: 'PresentationWillClientConfiguration';
  } | {
    __typename: 'PresentationWillItem';
  } | {
    __typename: 'Principal';
  } | {
    __typename: 'PrivateFoundation';
  } | {
    __typename: 'ProfessionalTeamRole';
  } | {
    __typename: 'Proposal';
  } | {
    __typename: 'ProposalScenario';
  } | {
    __typename: 'QPRTTrust';
  } | {
    __typename: 'QualifiedTuitionPersonalAccount';
  } | {
    __typename: 'ReleaseGroup';
  } | {
    __typename: 'ReminderEmailNotificationRecord';
  } | {
    __typename: 'RetirementPersonalAccount';
  } | {
    __typename: 'RevocableTrust';
  } | {
    __typename: 'Role';
  } | {
    __typename: 'SCorpBusinessEntity';
  } | {
    __typename: 'SLATTrust';
  } | {
    __typename: 'SSOConnection';
  } | {
    __typename: 'SalesforceExportAttempt';
  } | {
    __typename: 'ScheduledDistribution';
  } | {
    __typename: 'SoleProprietorshipBusinessEntity';
  } | {
    __typename: 'SubBrand';
  } | {
    __typename: 'SubBrandDisclaimerConfiguration';
  } | {
    __typename: 'Submission';
  } | {
    __typename: 'TaxDragConfig';
  } | {
    __typename: 'TaxDragOverride';
  } | {
    __typename: 'Team';
  } | {
    __typename: 'Tenant';
  } | {
    __typename: 'TenantApplicationConfiguration';
  } | {
    __typename: 'TenantBranding';
  } | {
    __typename: 'TenantDisclaimerConfiguration';
  } | {
    __typename: 'TenantDocument';
  } | {
    __typename: 'TenantReminderEmailsConfiguration';
  } | {
    __typename: 'TenantSSOConnection';
  } | {
    __typename: 'TenantSecurityConfiguration';
  } | {
    __typename: 'TenantSlideConfig';
  } | {
    __typename: 'TestCMKEncryption';
  } | {
    __typename: 'TestamentaryEntity';
  } | {
    __typename: 'TrustAdvisor';
  } | {
    __typename: 'TrustAdvisorRole';
  } | {
    __typename: 'Trustee';
  } | {
    __typename: 'TrusteeDuty';
  } | {
    __typename: 'User';
  } | {
    __typename: 'UserFeedback';
  } | {
    __typename: 'UserNotificationConfiguration';
  } | {
    __typename: 'WaterfallBundleConfiguration';
  } | {
    __typename: 'WaterfallBundleCoverPage';
  } | {
    __typename: 'WaterfallComparisonBundleConfiguration';
  } | {
    __typename: 'WaterfallComparisonTemplateBundleConfiguration';
  } | {
    __typename: 'WaterfallTemplateBundleConfiguration';
  } | {
    __typename: 'WorkOSOrganization';
  } | {
    __typename: 'WorkOSOrganizationDomain';
  } | {
    __typename: 'WorkflowTracker';
  } | null;
};
export type AdminFormQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;
export type AdminFormQuery = {
  __typename?: 'Query';
  node?: {
    __typename: 'AISuggestion';
  } | {
    __typename: 'AISuggestionEvidence';
  } | {
    __typename: 'AccessAgeParameter';
  } | {
    __typename: 'AccessParameter';
  } | {
    __typename: 'Account';
  } | {
    __typename: 'ActiveEstateInsightsPage';
  } | {
    __typename: 'Activity';
  } | {
    __typename: 'Address';
  } | {
    __typename: 'Answer';
  } | {
    __typename: 'AnswerEvidence';
  } | {
    __typename: 'AnswerRevision';
  } | {
    __typename: 'Approval';
  } | {
    __typename: 'AssetClass';
  } | {
    __typename: 'AssetGroup';
  } | {
    __typename: 'AssetStatic';
  } | {
    __typename: 'AssetV2';
  } | {
    __typename: 'AssetValuationV2';
  } | {
    __typename: 'AssetValueV2';
  } | {
    __typename: 'AsyncJob';
  } | {
    __typename: 'BalanceSheetBundleConfiguration';
  } | {
    __typename: 'BalanceSheetCategory';
  } | {
    __typename: 'BalanceSheetViewConfiguration';
  } | {
    __typename: 'BeneficiariesBundleConfiguration';
  } | {
    __typename: 'BeneficiariesTemplateBundleConfiguration';
  } | {
    __typename: 'Beneficiary';
  } | {
    __typename: 'BeneficiaryAccessParameter';
  } | {
    __typename: 'BeneficiaryDesignationGroup';
  } | {
    __typename: 'BeneficiaryDistribution';
  } | {
    __typename: 'BeneficiaryDistributionParameter';
  } | {
    __typename: 'BeneficiaryPage';
  } | {
    __typename: 'BeneficiaryPowerOfAppointment';
  } | {
    __typename: 'CCorpBusinessEntity';
  } | {
    __typename: 'CLTProposal';
  } | {
    __typename: 'CLTTrust';
  } | {
    __typename: 'CRTProposal';
  } | {
    __typename: 'CRTTrust';
  } | {
    __typename: 'Capability';
  } | {
    __typename: 'Cashflow';
  } | {
    __typename: 'ClientOrganization';
  } | {
    __typename: 'ClientPresentationV2';
  } | {
    __typename: 'ClientProfile';
  } | {
    __typename: 'ClientProfileRelationship';
  } | {
    __typename: 'Collaborator';
  } | {
    __typename: 'ComparedWaterfall';
  } | {
    __typename: 'CompletedEstateInsightsPage';
  } | {
    __typename: 'ControllingParty';
  } | {
    __typename: 'Conversation';
  } | {
    __typename: 'CoverPageConfiguration';
  } | {
    __typename: 'CustodialPersonalAccount';
  } | {
    __typename: 'DSUEPortability';
  } | {
    __typename: 'DiagramArtifact';
  } | {
    __typename: 'DiagramArtifactPrompt';
  } | {
    __typename: 'DispositionScenario';
  } | {
    __typename: 'DispositiveProvision';
  } | {
    __typename: 'DispositiveProvisionTemplate';
  } | {
    __typename: 'DividerBundleConfiguration';
  } | {
    __typename: 'DividerTemplateBundleConfiguration';
  } | {
    __typename: 'Document';
  } | {
    __typename: 'DocumentQuestion';
  } | {
    __typename: 'DocumentQuestionAnswers';
  } | {
    __typename: 'DocumentSummary';
  } | {
    __typename: 'DocumentSummaryPage';
  } | {
    __typename: 'DocumentSummaryPrompt';
  } | {
    __typename: 'DocumentSummaryPromptTestRun';
  } | {
    __typename: 'DocumentSummaryTemplateBundleConfiguration';
  } | {
    __typename: 'DonorAdvisedFund';
  } | {
    __typename: 'Employee';
  } | {
    __typename: 'EntitiesOverviewBundleConfiguration';
  } | {
    __typename: 'EntitiesOverviewBundleConfigurationEntity';
  } | {
    __typename: 'Entity';
  } | {
    __typename: 'EntityDiagram';
  } | {
    __typename: 'EntityDocumentRelationship';
  } | {
    __typename: 'EntityGraphView';
  } | {
    __typename: 'EntityGraphViewBundleConfiguration';
  } | {
    __typename: 'EntityNotes';
  } | {
    __typename: 'EntityProposal';
  } | {
    __typename: 'EntitySummaryBundleConfiguration';
  } | {
    __typename: 'EntitySummaryTemplateBundleConfiguration';
  } | {
    __typename: 'EntityTask';
  } | {
    __typename: 'EntityTaxInfo';
  } | {
    __typename: 'EstateInsight';
  } | {
    __typename: 'EstateInsightReference';
  } | {
    __typename: 'EstateInsightsBundleConfiguration';
  } | {
    __typename: 'EstateTaxScenario';
  } | {
    __typename: 'EstateWaterfall';
  } | {
    __typename: 'EstateWaterfallHypotheticalStateChange';
  } | {
    __typename: 'EstateWaterfallHypotheticalTransfer';
  } | {
    __typename: 'EstateWaterfallMessageContext';
  } | {
    __typename: 'EstateWaterfallVisualizationConfig';
  } | {
    __typename: 'EstateWaterfallVisualizationFilter';
  } | {
    __typename: 'FamilyTreeBundleConfiguration';
  } | {
    __typename: 'FamilyTreeConfiguration';
  } | {
    __typename: 'FeatureFlag';
  } | {
    __typename: 'FeatureFlagQueryRule';
  } | {
    __typename: 'File';
  } | {
    __typename: 'FilePage';
  } | {
    __typename: 'FileParagraph';
  } | ({
    __typename: 'Form';
  } & AdminFormsPage_FormFragment) | {
    __typename: 'FormVersion';
  } | {
    __typename: 'GPBusinessEntity';
  } | {
    __typename: 'GRATAnnuityV2';
  } | {
    __typename: 'GRATProposalScenario';
  } | {
    __typename: 'GRATTrust';
  } | {
    __typename: 'GiftingProposal';
  } | {
    __typename: 'GiftingProposalCashFlow';
  } | {
    __typename: 'GiftingProposalGift';
  } | {
    __typename: 'GiftingProposalGiftSender';
  } | {
    __typename: 'GiftingProposalPortfolio';
  } | {
    __typename: 'GiftingProposalScenario';
  } | {
    __typename: 'GraphVisualizationGroup';
  } | {
    __typename: 'GrowthProfile';
  } | {
    __typename: 'GrowthProfileOverride';
  } | {
    __typename: 'Household';
  } | {
    __typename: 'HypotheticalCLT';
  } | {
    __typename: 'HypotheticalCRT';
  } | {
    __typename: 'HypotheticalGRAT';
  } | {
    __typename: 'HypotheticalInsurance';
  } | {
    __typename: 'HypotheticalSaleLoan';
  } | {
    __typename: 'HypotheticalTransferAsset';
  } | {
    __typename: 'HypotheticalTransferFundingSource';
  } | {
    __typename: 'HypotheticalWaterfallDispositiveProvisionTemplate';
  } | {
    __typename: 'ILITCrummeyLetter';
  } | {
    __typename: 'ILITTrust';
  } | {
    __typename: 'Image';
  } | {
    __typename: 'IncomeTaxPaymentConfig';
  } | {
    __typename: 'IndividualPersonalAccount';
  } | {
    __typename: 'InferredField';
  } | {
    __typename: 'InferredFieldEvidence';
  } | {
    __typename: 'InsightsTemplateBundleConfiguration';
  } | {
    __typename: 'InsurancePersonalAccount';
  } | {
    __typename: 'InsurancePolicy';
  } | {
    __typename: 'InsurancePremiumPayment';
  } | {
    __typename: 'IntegrationAssetClass';
  } | {
    __typename: 'IntegrationCashflow';
  } | {
    __typename: 'IntegrationClient';
  } | {
    __typename: 'IntegrationConfiguration';
  } | {
    __typename: 'IntegrationEntity';
  } | {
    __typename: 'IntegrationInsurance';
  } | {
    __typename: 'IntegrationLiability';
  } | {
    __typename: 'IntegrationPerson';
  } | {
    __typename: 'IrrevocableTrust';
  } | {
    __typename: 'JointPersonalAccount';
  } | {
    __typename: 'KGNode';
  } | {
    __typename: 'KGRelationship';
  } | {
    __typename: 'KGRoot';
  } | {
    __typename: 'KGV2Document';
  } | {
    __typename: 'KGV2DocumentChange';
  } | {
    __typename: 'KGV2DocumentModification';
  } | {
    __typename: 'KGV2Graph';
  } | {
    __typename: 'KGV2Node';
  } | {
    __typename: 'KGV2NodeAlias';
  } | {
    __typename: 'KGV2NodeEvidence';
  } | {
    __typename: 'KGV2Statement';
  } | {
    __typename: 'KGV2StatementEvidence';
  } | {
    __typename: 'KGV2StatementSupersession';
  } | {
    __typename: 'KeyPerson';
  } | {
    __typename: 'KeyPersonRole';
  } | {
    __typename: 'LLCBusinessEntity';
  } | {
    __typename: 'LPBusinessEntity';
  } | {
    __typename: 'LiabilitiesBundleConfiguration';
  } | {
    __typename: 'Liability';
  } | {
    __typename: 'LiabilityPayment';
  } | {
    __typename: 'LifeInsuranceBundleConfiguration';
  } | {
    __typename: 'LifetimeExclusionEvent';
  } | {
    __typename: 'LoggedTransfer';
  } | {
    __typename: 'LuminaryOrganization';
  } | {
    __typename: 'LuminaryTenantJIT';
  } | {
    __typename: 'ManagedSFTPConnection';
  } | {
    __typename: 'Memo';
  } | {
    __typename: 'MemoPrompt';
  } | {
    __typename: 'Message';
  } | {
    __typename: 'MissingDocumentOverride';
  } | {
    __typename: 'MissingDocumentsPage';
  } | {
    __typename: 'ModelMapping';
  } | {
    __typename: 'NotificationApp';
  } | {
    __typename: 'NotificationPreference';
  } | {
    __typename: 'OpenaiSdkConfig';
  } | {
    __typename: 'OrganizationApplicationConfiguration';
  } | {
    __typename: 'OrganizationDisclaimerConfiguration';
  } | {
    __typename: 'OwnershipStake';
  } | {
    __typename: 'PlatformDocument';
  } | {
    __typename: 'PlatformFile';
  } | {
    __typename: 'PlatformFilePage';
  } | {
    __typename: 'PlatformFileParagraph';
  } | {
    __typename: 'PresentationApprovalRequest';
  } | {
    __typename: 'PresentationAssetDistributionBundleConfiguration';
  } | {
    __typename: 'PresentationAssetDistributionItemConfiguration';
  } | {
    __typename: 'PresentationAssetDistributionItemDetail';
  } | {
    __typename: 'PresentationBundle';
  } | {
    __typename: 'PresentationBundleCoverPage';
  } | {
    __typename: 'PresentationBusinessOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationBusinessOverviewBusinessConfiguration';
  } | {
    __typename: 'PresentationBusinessOverviewItem';
  } | {
    __typename: 'PresentationCoverPage';
  } | {
    __typename: 'PresentationCoverSlideConfig';
  } | {
    __typename: 'PresentationCustomPage';
  } | {
    __typename: 'PresentationCustomPageBundleConfiguration';
  } | {
    __typename: 'PresentationDiagramPage';
  } | {
    __typename: 'PresentationDocumentsReviewedBundleConfiguration';
  } | {
    __typename: 'PresentationDocumentsReviewedDocument';
  } | {
    __typename: 'PresentationFamilyOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationFamilyOverviewMemberConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveBundleConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveClientConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveItem';
  } | {
    __typename: 'PresentationItemCitation';
  } | {
    __typename: 'PresentationPage';
  } | {
    __typename: 'PresentationPlanningOpportunitiesBundleConfiguration';
  } | {
    __typename: 'PresentationPlanningOpportunitiesItem';
  } | {
    __typename: 'PresentationPowerOfAttorneyBundleConfiguration';
  } | {
    __typename: 'PresentationPowerOfAttorneyClientConfiguration';
  } | {
    __typename: 'PresentationPowerOfAttorneyItem';
  } | {
    __typename: 'PresentationTemplate';
  } | {
    __typename: 'PresentationTemplateBundle';
  } | {
    __typename: 'PresentationTemplateCoverPage';
  } | {
    __typename: 'PresentationTemplateCustomPage';
  } | {
    __typename: 'PresentationTemplateDiagramPage';
  } | {
    __typename: 'PresentationTemplatePage';
  } | {
    __typename: 'PresentationTrustOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationTrustOverviewItem';
  } | {
    __typename: 'PresentationTrustOverviewTrustConfiguration';
  } | {
    __typename: 'PresentationWillBundleConfiguration';
  } | {
    __typename: 'PresentationWillClientConfiguration';
  } | {
    __typename: 'PresentationWillItem';
  } | {
    __typename: 'Principal';
  } | {
    __typename: 'PrivateFoundation';
  } | {
    __typename: 'ProfessionalTeamRole';
  } | {
    __typename: 'Proposal';
  } | {
    __typename: 'ProposalScenario';
  } | {
    __typename: 'QPRTTrust';
  } | {
    __typename: 'QualifiedTuitionPersonalAccount';
  } | {
    __typename: 'ReleaseGroup';
  } | {
    __typename: 'ReminderEmailNotificationRecord';
  } | {
    __typename: 'RetirementPersonalAccount';
  } | {
    __typename: 'RevocableTrust';
  } | {
    __typename: 'Role';
  } | {
    __typename: 'SCorpBusinessEntity';
  } | {
    __typename: 'SLATTrust';
  } | {
    __typename: 'SSOConnection';
  } | {
    __typename: 'SalesforceExportAttempt';
  } | {
    __typename: 'ScheduledDistribution';
  } | {
    __typename: 'SoleProprietorshipBusinessEntity';
  } | {
    __typename: 'SubBrand';
  } | {
    __typename: 'SubBrandDisclaimerConfiguration';
  } | {
    __typename: 'Submission';
  } | {
    __typename: 'TaxDragConfig';
  } | {
    __typename: 'TaxDragOverride';
  } | {
    __typename: 'Team';
  } | {
    __typename: 'Tenant';
  } | {
    __typename: 'TenantApplicationConfiguration';
  } | {
    __typename: 'TenantBranding';
  } | {
    __typename: 'TenantDisclaimerConfiguration';
  } | {
    __typename: 'TenantDocument';
  } | {
    __typename: 'TenantReminderEmailsConfiguration';
  } | {
    __typename: 'TenantSSOConnection';
  } | {
    __typename: 'TenantSecurityConfiguration';
  } | {
    __typename: 'TenantSlideConfig';
  } | {
    __typename: 'TestCMKEncryption';
  } | {
    __typename: 'TestamentaryEntity';
  } | {
    __typename: 'TrustAdvisor';
  } | {
    __typename: 'TrustAdvisorRole';
  } | {
    __typename: 'Trustee';
  } | {
    __typename: 'TrusteeDuty';
  } | {
    __typename: 'User';
  } | {
    __typename: 'UserFeedback';
  } | {
    __typename: 'UserNotificationConfiguration';
  } | {
    __typename: 'WaterfallBundleConfiguration';
  } | {
    __typename: 'WaterfallBundleCoverPage';
  } | {
    __typename: 'WaterfallComparisonBundleConfiguration';
  } | {
    __typename: 'WaterfallComparisonTemplateBundleConfiguration';
  } | {
    __typename: 'WaterfallTemplateBundleConfiguration';
  } | {
    __typename: 'WorkOSOrganization';
  } | {
    __typename: 'WorkOSOrganizationDomain';
  } | {
    __typename: 'WorkflowTracker';
  } | null;
};
export type PublishedFormsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;
export type PublishedFormsQuery = {
  __typename?: 'Query';
  forms: {
    __typename?: 'FormConnection';
    edges?: Array<{
      __typename?: 'FormEdge';
      node?: {
        __typename?: 'Form';
        id: string;
        draftConfig: any;
        currentPublishedVersion?: {
          __typename?: 'FormVersion';
          id: string;
          version: number;
          schemaVersion: number;
          config: any;
        } | null;
      } | null;
    } | null> | null;
  };
};
export type CreateFormMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateFormInput;
}>;
export type CreateFormMutation = {
  __typename?: 'Mutation';
  createForm: ({
    __typename?: 'Form';
  } & AdminFormsPage_FormFragment);
};
export type UpdateFormMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateFormInput;
}>;
export type UpdateFormMutation = {
  __typename?: 'Mutation';
  updateForm: ({
    __typename?: 'Form';
  } & AdminFormsPage_FormFragment);
};
export type PublishFormMutationVariables = Types.Exact<{
  input: Types.PublishFormInput;
}>;
export type PublishFormMutation = {
  __typename?: 'Mutation';
  publishForm: {
    __typename?: 'PublishFormPayload';
    form: ({
      __typename?: 'Form';
    } & AdminFormsPage_FormFragment);
    version: {
      __typename?: 'FormVersion';
      id: string;
      version: number;
      schemaVersion: number;
      config: any;
    };
  };
};
export const Operations = {
  Query: {
    FormDraftImportContract: 'FormDraftImportContract' as const,
    AdminForms: 'AdminForms' as const,
    FormVersionConfig: 'FormVersionConfig' as const,
    AdminForm: 'AdminForm' as const,
    PublishedForms: 'PublishedForms' as const
  },
  Mutation: {
    NormalizeFormDraftConfig: 'NormalizeFormDraftConfig' as const,
    CreateForm: 'CreateForm' as const,
    UpdateForm: 'UpdateForm' as const,
    PublishForm: 'PublishForm' as const
  },
  Fragment: {
    AdminFormsPage_Form: 'AdminFormsPage_Form' as const
  }
};

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy
    }
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options
  };
}
export const AdminFormsPage_FormFragmentDoc = gql`
    fragment AdminFormsPage_Form on Form {
  id
  name
  description
  draftSchemaVersion
  draftConfig
  updatedAt
  currentPublishedVersion {
    id
    version
  }
}
    `;
export const FormDraftImportContractDocument = gql`
    query FormDraftImportContract {
  formDraftImportContract {
    schemaVersion
    jsonSchema
    sampleJson
  }
}
    `;

/**
 * __useFormDraftImportContractQuery__
 *
 * To run a query within a React component, call `useFormDraftImportContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormDraftImportContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormDraftImportContractQuery({
 *   variables: {
 *   },
 * });
 */
export function useFormDraftImportContractQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(FormDraftImportContractDocument, withFetchPolicyContext(options));
}
export function useFormDraftImportContractLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(FormDraftImportContractDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useFormDraftImportContractSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(FormDraftImportContractDocument, withFetchPolicyContext(options));
}
export type FormDraftImportContractQueryHookResult = ReturnType<typeof useFormDraftImportContractQuery>;
export type FormDraftImportContractLazyQueryHookResult = ReturnType<typeof useFormDraftImportContractLazyQuery>;
export type FormDraftImportContractSuspenseQueryHookResult = ReturnType<typeof useFormDraftImportContractSuspenseQuery>;
export type FormDraftImportContractQueryResult = Apollo.QueryResult<FormDraftImportContractQuery, FormDraftImportContractQueryVariables>;
export const NormalizeFormDraftConfigDocument = gql`
    mutation NormalizeFormDraftConfig($json: String!) {
  normalizeFormDraftConfig(json: $json)
}
    `;
export type NormalizeFormDraftConfigMutationFn = Apollo.MutationFunction<NormalizeFormDraftConfigMutation, NormalizeFormDraftConfigMutationVariables>;

/**
 * __useNormalizeFormDraftConfigMutation__
 *
 * To run a mutation, you first call `useNormalizeFormDraftConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNormalizeFormDraftConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [normalizeFormDraftConfigMutation, { data, loading, error }] = useNormalizeFormDraftConfigMutation({
 *   variables: {
 *      json: // value for 'json'
 *   },
 * });
 */
export function useNormalizeFormDraftConfigMutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(NormalizeFormDraftConfigDocument, options);
}
export type NormalizeFormDraftConfigMutationHookResult = ReturnType<typeof useNormalizeFormDraftConfigMutation>;
export type NormalizeFormDraftConfigMutationResult = Apollo.MutationResult<NormalizeFormDraftConfigMutation>;
export type NormalizeFormDraftConfigMutationOptions = Apollo.BaseMutationOptions<NormalizeFormDraftConfigMutation, NormalizeFormDraftConfigMutationVariables>;
export const AdminFormsDocument = gql`
    query AdminForms {
  forms(
    first: 100
    orderBy: [{field: updated_at, direction: DESC}]
    where: {archivedAtIsNil: true}
  ) {
    edges {
      node {
        ...AdminFormsPage_Form
        versions(orderBy: [{field: created_at, direction: DESC}]) {
          edges {
            node {
              id
              version
            }
          }
        }
      }
    }
  }
}
    ${AdminFormsPage_FormFragmentDoc}`;

/**
 * __useAdminFormsQuery__
 *
 * To run a query within a React component, call `useAdminFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFormsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(AdminFormsDocument, withFetchPolicyContext(options));
}
export function useAdminFormsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(AdminFormsDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useAdminFormsSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(AdminFormsDocument, withFetchPolicyContext(options));
}
export type AdminFormsQueryHookResult = ReturnType<typeof useAdminFormsQuery>;
export type AdminFormsLazyQueryHookResult = ReturnType<typeof useAdminFormsLazyQuery>;
export type AdminFormsSuspenseQueryHookResult = ReturnType<typeof useAdminFormsSuspenseQuery>;
export type AdminFormsQueryResult = Apollo.QueryResult<AdminFormsQuery, AdminFormsQueryVariables>;
export const FormVersionConfigDocument = gql`
    query FormVersionConfig($id: ID!) {
  node(id: $id) {
    __typename
    ... on FormVersion {
      id
      config
    }
  }
}
    `;

/**
 * __useFormVersionConfigQuery__
 *
 * To run a query within a React component, call `useFormVersionConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormVersionConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormVersionConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormVersionConfigQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(FormVersionConfigDocument, withFetchPolicyContext(options));
}
export function useFormVersionConfigLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(FormVersionConfigDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useFormVersionConfigSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(FormVersionConfigDocument, withFetchPolicyContext(options));
}
export type FormVersionConfigQueryHookResult = ReturnType<typeof useFormVersionConfigQuery>;
export type FormVersionConfigLazyQueryHookResult = ReturnType<typeof useFormVersionConfigLazyQuery>;
export type FormVersionConfigSuspenseQueryHookResult = ReturnType<typeof useFormVersionConfigSuspenseQuery>;
export type FormVersionConfigQueryResult = Apollo.QueryResult<FormVersionConfigQuery, FormVersionConfigQueryVariables>;
export const AdminFormDocument = gql`
    query AdminForm($id: ID!) {
  node(id: $id) {
    __typename
    ...AdminFormsPage_Form
  }
}
    ${AdminFormsPage_FormFragmentDoc}`;

/**
 * __useAdminFormQuery__
 *
 * To run a query within a React component, call `useAdminFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminFormQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(AdminFormDocument, withFetchPolicyContext(options));
}
export function useAdminFormLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(AdminFormDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useAdminFormSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(AdminFormDocument, withFetchPolicyContext(options));
}
export type AdminFormQueryHookResult = ReturnType<typeof useAdminFormQuery>;
export type AdminFormLazyQueryHookResult = ReturnType<typeof useAdminFormLazyQuery>;
export type AdminFormSuspenseQueryHookResult = ReturnType<typeof useAdminFormSuspenseQuery>;
export type AdminFormQueryResult = Apollo.QueryResult<AdminFormQuery, AdminFormQueryVariables>;
export const PublishedFormsDocument = gql`
    query PublishedForms {
  forms(
    first: 100
    orderBy: [{field: updated_at, direction: DESC}]
    where: {archivedAtIsNil: true, hasCurrentPublishedVersion: true}
  ) {
    edges {
      node {
        id
        draftConfig
        currentPublishedVersion {
          id
          version
          schemaVersion
          config
        }
      }
    }
  }
}
    `;

/**
 * __usePublishedFormsQuery__
 *
 * To run a query within a React component, call `usePublishedFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishedFormsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(PublishedFormsDocument, withFetchPolicyContext(options));
}
export function usePublishedFormsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(PublishedFormsDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function usePublishedFormsSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(PublishedFormsDocument, withFetchPolicyContext(options));
}
export type PublishedFormsQueryHookResult = ReturnType<typeof usePublishedFormsQuery>;
export type PublishedFormsLazyQueryHookResult = ReturnType<typeof usePublishedFormsLazyQuery>;
export type PublishedFormsSuspenseQueryHookResult = ReturnType<typeof usePublishedFormsSuspenseQuery>;
export type PublishedFormsQueryResult = Apollo.QueryResult<PublishedFormsQuery, PublishedFormsQueryVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($input: AugmentedCreateFormInput!) {
  createForm(input: $input) {
    ...AdminFormsPage_Form
  }
}
    ${AdminFormsPage_FormFragmentDoc}`;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(CreateFormDocument, options);
}
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($input: AugmentedUpdateFormInput!) {
  updateForm(input: $input) {
    ...AdminFormsPage_Form
  }
}
    ${AdminFormsPage_FormFragmentDoc}`;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(UpdateFormDocument, options);
}
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const PublishFormDocument = gql`
    mutation PublishForm($input: PublishFormInput!) {
  publishForm(input: $input) {
    form {
      ...AdminFormsPage_Form
    }
    version {
      id
      version
      schemaVersion
      config
    }
  }
}
    ${AdminFormsPage_FormFragmentDoc}`;
export type PublishFormMutationFn = Apollo.MutationFunction<PublishFormMutation, PublishFormMutationVariables>;

/**
 * __usePublishFormMutation__
 *
 * To run a mutation, you first call `usePublishFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishFormMutation, { data, loading, error }] = usePublishFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishFormMutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(PublishFormDocument, options);
}
export type PublishFormMutationHookResult = ReturnType<typeof usePublishFormMutation>;
export type PublishFormMutationResult = Apollo.MutationResult<PublishFormMutation>;
export type PublishFormMutationOptions = Apollo.BaseMutationOptions<PublishFormMutation, PublishFormMutationVariables>;